<template>
  <BaseListV2 :model-class="Profile" :collection-filter="profileFilter">
    <template #filters>
      <div>
        <p>Organisation</p>
        <OrganisationSelector @selected="organisationSelected" />
      </div>
      <v-responsive min-width="100" max-width="250">
        <v-select
          v-model="kind"
          color="primary"
          label="User kind"
          placeholder="Any"
          density="compact"
          :items="[
            { title: 'Any', value: null },
            { title: 'Human', value: 'human' },
            { title: 'Machine', value: 'machine' },
          ]"
        />
      </v-responsive>
      <v-responsive min-width="100" max-width="250">
        <v-text-field
          v-model="usernameSearch"
          density="compact"
          label="Search"
          placeholder="Search by username..."
          icon="magnify"
        />
      </v-responsive>
    </template>
  </BaseListV2>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { CollectionFilter } from '@/api/ApiClient'
import BaseListV2 from '@/components/common/BaseListV2.vue'
import OrganisationSelector from '@/components/navigation/sidebar/OrganisationSelector.vue'
import { Organisation } from '@/models/core/organisation'
import { Profile } from '@/models/core/profile'

const store = useStore()
const route = useRoute()

// Reactive references
const kind = ref<string | null>((route.query.kind as string) || 'human')
const selectedOrg = ref<string>(
  (route.query.organisation as string) ||
    store.getters['global/organisation'].id
)
const usernameSearch = ref<string | null>(
  (route.query.search as string) || null
)

// Computed properties
const profileFilter = computed<CollectionFilter>(() => ({
  organisation: selectedOrg.value,
  kind: kind.value,
  search: usernameSearch.value,
}))

const organisationSelected = (newOrg: Organisation): void => {
  selectedOrg.value = newOrg.id
}
</script>
